import { render, staticRenderFns } from "./ListaAsignacionEnvios.vue?vue&type=template&id=7bf1644c&scoped=true&"
import script from "./ListaAsignacionEnvios.vue?vue&type=script&lang=js&"
export * from "./ListaAsignacionEnvios.vue?vue&type=script&lang=js&"
import style0 from "./ListaAsignacionEnvios.vue?vue&type=style&index=0&id=7bf1644c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf1644c",
  null
  
)

export default component.exports